module.exports = __webpack_public_path__ + "static/media/unasaka-ryou.7de2e6e0.png";